import React from 'react';
import { Layer, Source } from 'react-map-gl';
import { DIVISION_BOUNDRIES } from '../../../../../appConstants';
import { createSelector } from 'reselect';

interface IMapboxDivisionLayerProps {
    polygonId : string;
    strokeId : string;
    labelId : string;

    polygonBeforeId ?: string;
    strokeBeforeId ?: string;
    labelBeforeId ?: string;

    minZoom ?: number;
    maxZoom ?: number;
    
    divisionGuid ?: string | null;

    labelsVisible ?: boolean;
    visible ?: boolean;
}

interface IMapboxDivisionLayerState {}

export default class MapboxDivisionLayer extends React.PureComponent<IMapboxDivisionLayerProps, IMapboxDivisionLayerState> {
    constructor(props : IMapboxDivisionLayerProps) {
        super(props);
        this.state = {};
    }

    private readonly getDivisionGuid = (props : IMapboxDivisionLayerProps) => props.divisionGuid;

    private getFilter = createSelector(
        [
            this.getDivisionGuid,
        ],
        (
            divisionGuid,
        ) => {
            const result : Array<unknown> = [];

            if (divisionGuid) {
                result.push(['==', ['literal', divisionGuid], ['get', 'divGuid']]);
            }
            
            return [
                'all',
                ...result,
            ];
        },
    );

    public readonly render = () => {
        const {
            minZoom = 0,
            maxZoom = 20,
            labelId,
            strokeId,
            polygonId,
            labelBeforeId,
            polygonBeforeId,
            strokeBeforeId,
            visible,
            labelsVisible,
        } = this.props;

        const filter = this.getFilter(this.props);

        return (
            <Source
                id='polygon_division_source'
                type='vector'
                tiles={[
                    `${GEO_SERVER_URL}/geoserver/${GEO_SERVER_WORKSPACE}/gwc/service/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&LAYER=farm_divisions&STYLE=&TILEMATRIX=EPSG:900913:{z}&TILEMATRIXSET=EPSG:900913&FORMAT=application/vnd.mapbox-vector-tile&TILECOL={x}&TILEROW={y}`,
                ]}
                minzoom={minZoom}
                maxzoom={maxZoom}
                bounds={DIVISION_BOUNDRIES}
            >
                <Layer {...{
                    id: polygonId,
                    'source-layer': 'farm_divisions',
                    type: 'fill',
                    minzoom: minZoom,
                    maxzoom: maxZoom,
                    'layout': {
                        visibility: visible ? 'visible' : 'none',
                    },
                    'paint': {
                        'fill-color': ['get', 'divColor'],
                        'fill-opacity': 0.2,
                    },
                    'road-label-simple': true,
                    filter,
                    beforeId: polygonBeforeId,
                }} />
                <Layer {...{
                    id: strokeId,
                    'source-layer': 'farm_divisions',
                    'type': 'line',
                    minzoom: minZoom,
                    maxzoom: maxZoom,
                    'layout': {
                        visibility: visible ? 'visible' : 'none',
                    },
                    'paint': {
                        'line-color': ['get', 'divColor'],
                        'line-width': 3,
                    },
                    filter,
                    beforeId: strokeBeforeId,
                }} />
                <Layer {...{
                    id: labelId,
                    'source-layer': 'farm_divisions',
                    type: 'symbol',
                    minzoom: minZoom,
                    maxzoom: maxZoom,
                    layout: {
                        'text-field': [
                            'format',
                            [
                                'get',
                                'divName',
                            ],
                            {
                                'font-scale': 0.8,
                            },
                        ],
                        'text-justify': 'center',
                        'text-allow-overlap': true,
                        visibility: visible && labelsVisible ? 'visible' : 'none',
                    },
                    paint: {
                        'text-opacity': 1,
                        'text-color': '#FFFFFF',
                        'text-halo-color': '#000000',
                        'text-halo-width': 2,
                        'text-halo-blur': 1,
                    },
                    filter,
                    beforeId: labelBeforeId,
                }}
                />
            </Source>
        );
    };
}
